import { ImplementationFunctionParams } from '@/backend/access/implementationFunction/types';

export class ImplementationFunction {
  id: string;
  implementationId: string;
  functionTitle: string;
  functionDescription?: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  /** Its implementation's org ("orgId"); present when read from the database, not on create/update results. */
  propelOrgId?: string;

  constructor(params: ImplementationFunctionParams) {
    this.id = params.id;
    this.implementationId = params.implementationId;
    this.functionTitle = params.functionTitle;
    this.functionDescription = params.functionDescription;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.propelOrgId = params.orgId;
  }
}
